const ACTION_LABEL = {
  submitted: "Submitted for review",
  finalized: "Finalized",
  reopened: "Reopened",
};

const ACTION_TINT = {
  submitted: "bg-amber-100 text-amber-900 border-amber-300",
  finalized: "bg-emerald-100 text-emerald-800 border-emerald-300",
  reopened: "bg-sky-100 text-sky-900 border-sky-300",
};

export default function ReportAuditTrail({ entries }) {
  if (!entries.length) {
    return (
      <div className="text-xs text-slate-500" data-testid="audit-empty">
        No status transitions yet.
      </div>
    );
  }
  return (
    <ol data-testid="audit-trail" className="space-y-3">
      {entries.map((e) => (
        <li
          key={e.id}
          data-testid={`audit-entry-${e.id}`}
          className="flex items-start gap-3"
        >
          <span
            className={`mt-0.5 inline-flex items-center rounded-md border px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide ${
              ACTION_TINT[e.action] ||
              "bg-slate-100 text-slate-700 border-slate-300"
            }`}
          >
            {ACTION_LABEL[e.action] || e.action}
          </span>
          <div className="flex-1 min-w-0">
            <div className="text-xs text-slate-700">
              <span className="font-semibold text-slate-900">
                {e.actor_name}
              </span>{" "}
              · {e.from_status} → {e.to_status}
            </div>
            <div className="text-[10px] uppercase tracking-wider text-slate-500 mt-0.5 font-data">
              {new Date(e.created_at).toLocaleString()}
            </div>
            {e.note && (
              <div className="text-xs text-slate-600 mt-1 italic">
                "{e.note}"
              </div>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
